import apiClient from "../../utils/apiclient";

interface RequestData {
  admin_id: string;
  req_desc: string;
}

export const getrequestdata = async (
  id: string, 
  token?: string, 
  data?: RequestData
) => {
  const url = `/admin/team-member/edit-req`;

  return await apiClient.post(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};



export const profiledata = async (
  body:{id:string},
  token?: string
) => {
  const url = `/admin/team-member/get-profile-data`;

  return await apiClient.post(url, body,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
